import ProtectedRoute from "./components/ProtectedRoute";
import { authContext, AuthProvider } from "./context/auth";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import Spinner from "./components/Spinner";
import Job from "./components/pages/Job";
import CenterContainer from "./components/CenterContainer";
import Background from "./components/Background";


function AppComponent() {
	const {loading} = useContext(authContext);

	if (loading) {
		return (<CenterContainer>
			<Spinner />
		</CenterContainer>)
	}
	else {
		return (
			<>
				<Router>
					<Routes>
						<Route
							path={"/jobs/:id"}
							element={
								<ProtectedRoute>
									<Job />
								</ProtectedRoute>
							}
						/>

						{/*<Route path={'/signIn'} element={<><SignIn /></>}></Route>*/}
						{/* <Route path={'/signUp'} element={<><SignUp /></>}></Route> */}
						{/*<Route path={'/resetPassword'} element={<><ResetPassword /></>}></Route>*/}
						{/*<Route path={'/forgotPassword'} element={<><ForgotPassword /></>}></Route>*/}

						<Route path="*" element={<h2 className="mt-3">Invalid link</h2>} />
					</Routes>
				</Router>
			</>
		);
	}
}


function App() {
	return (
		<>
			<AuthProvider>
				<Background />
				<AppComponent />
			</AuthProvider>
		</>
	);
}

export default App;
